import XmlNode from '../helpers/xml';

import orderItemTemplate from '../helpers/orderitemtitleist';

const specialMapping = {
    //     <Features>
    //         <Feature>CA001</Feature>
    //         <Option>CA-RH</Option>
    //     </Features>
    CA001: 'v-ags-orientation-code',

    //     <Features>
    //         <Feature>CB001</Feature>
    //         <Option>CBW-5614</Option>
    //     </Features>
    CB001: 'v-ags-set-comp-code',
};

const extraDefaults = {
    //     <Features>
    //         <Feature>CL200</Feature>
    //         <Option>CL-ALACART2</Option>
    //     </Features>
    CL200: 'CL-ALACART2',
};

function isEmpty(v) {
    return v == null || v.length === 0;
}

export default {
    mapFromAttribute(controller, name) {
        if (!isEmpty(controller.blueprint.custom[name])) {
            return controller.blueprint.custom[name];
        }

        // eslint-disable-next-line no-restricted-syntax
        for (const s of controller.state) {
            if (!isEmpty(s.component.custom?.[name])) {
                return s.component.custom[name];
            }
        }

        // eslint-disable-next-line no-restricted-syntax
        for (const s of controller.state) {
            if (!isEmpty(s.placement.custom?.[name])) {
                return s.placement.custom[name];
            }
        }

        return null;
    },

    checkComponentForCode(controller, component, i, code, used) {
        let maybeMatch = false;

        if (used.has(component.placementIndependentCode)) {
            return null;
        }

        if (component.custom[`v-ags-also-${i}-feature-once`] === code) {
            maybeMatch = true;

            used.add(component.placementIndependentCode);
        }

        if (component.custom[`v-ags-also-${i}-feature`] === code) {
            maybeMatch = true;
        }

        if (!maybeMatch) {
            return null;
        }

        if (component.custom[`v-ags-also-${i}-text`]) {
            return component.custom[component.custom[`v-ags-also-${i}-text`]] || '';
        }

        if (component.custom[`v-ags-also-${i}-empty-text`]) {
            const [agsCode, key] = component.custom[`v-ags-also-${i}-empty-text`].split(',').map((x) => x.trim()).filter((x) => x.length > 0);

            if ((component.custom[key] || '').length === 0) {
                return agsCode;
            }
        }

        if (component.custom[`v-ags-also-${i}-filled-text`]) {
            const [agsCode, key] = component.custom[`v-ags-also-${i}-filled-text`].split(',').map((x) => x.trim()).filter((x) => x.length > 0);

            if ((component.custom[key] || '').length > 0) {
                return agsCode;
            }
        }

        if (component.custom[`v-ags-also-${i}-from`]) {
            const selected = controller.selectedAtPlacement(component.custom[`v-ags-also-${i}-from`]);

            if (selected) {
                return selected.custom['v-ags-code'];
            }
        }

        if (component.custom[`v-ags-also-${i}-code`]) {
            return component.custom[`v-ags-also-${i}-code`];
        }

        return null;
    },

    mapFromAgsCode(controller, code, used) {
        if (extraDefaults[code]) {
            return extraDefaults[code];
        }

        // eslint-disable-next-line no-restricted-syntax
        for (const s of controller.state) {
            if (s.placement.custom?.['v-ags-feature'] === code) {
                // Special case for addons redirect.
                if (s.component.custom['v-stamping-use-symbols-addon'] === 'yes') {
                    if (s.component.custom['v-stamping-supports-snow-symbol']) {
                        return s.component.custom['v-stamping-supports-snow-symbol'];
                    }
                }

                return s.component.custom['v-ags-code'];
            }

            for (let i = 1; i <= 9; i += 1) {
                if (s.component.custom['v-stamping-use-symbols-addon'] === 'yes') {
                    const snowMapped = this.checkComponentForCode(controller, s.component, `${i}-snow`, code, used);
                    if (snowMapped) {
                        return snowMapped;
                    }
                }
            }

            for (let i = 1; i <= 9; i += 1) {
                const mapped = this.checkComponentForCode(controller, s.component, `${i}`, code, used);
                if (mapped) {
                    return mapped;
                }
            }
        }

        return null;
    },

    formatAgsData(controller) {
        const used = new Set();

        const xml = new XmlNode();

        // <Detail>

        const detail = xml.node('Detail');

        //     <Item>883DC</Item>
        detail.textOnly('Item', controller.blueprint.custom['v-ags-code']);

        //     <Quantity>1</Quantity>
        detail.textOnly('Quantity', '1');

        //     <DiscountCode>260</DiscountCode>
        let discountCode = '260';
        if (controller.blueprint?.custom['v-discount-code']) {
            discountCode = controller.blueprint?.custom['v-discount-code'];
        }
        detail.textOnly('DiscountCode', discountCode);

        //     <Comments></Comments>
        // Does not look like this is the actual comment.
        detail.textOnly('Comments', '');

        //     <OBJDCD></OBJDCD>
        // ¯\_(ツ)_/¯
        detail.textOnly('OBJDCD', '');

        //     <OBPIDE></OBPIDE>
        detail.textOnly('OBPIDE', '');

        //     <WBDLSP></WBDLSP>
        detail.textOnly('WBDLSP', '');

        //     <AGNO></AGNO>
        detail.textOnly('AGNO', '');

        const structure = JSON.parse(controller.blueprint.custom['v-ags-data-strucure']);

        // eslint-disable-next-line no-restricted-syntax
        for (const targetCode of structure) {
            let value = null;

            if (specialMapping[targetCode.code]) {
                value = this.mapFromAttribute(controller, specialMapping[targetCode.code]);
            } else {
                value = this.mapFromAgsCode(controller, targetCode.code, used);
            }

            if (value == null) {
                if (targetCode.default && targetCode.default.length > 0) {
                    value = targetCode.default;
                }
            }

            // No value should be selected at the placeholder level.
            // if (value == null) {
            //     if (targetCode.noValue && targetCode.noValue.length > 0) {
            //         value = targetCode.noValue;
            //     }
            // }

            if (value != null) {
                const f = detail.node('Features');
                f.textOnly('Feature', targetCode.code);
                f.textOnly('Option', value);
            }
        }

        return xml.toString();
    },

    formatOptionsData(controller, productData, includeNames) {
        const options = {};

        // eslint-disable-next-line no-restricted-syntax
        for (const s of controller.state) {
            if (s.component.custom['v-sfcc-option-id']) {
                if (s.component.custom['v-sfcc-option-default-value']) {
                    if (options[s.component.custom['v-sfcc-option-id']] == null) {
                        options[s.component.custom['v-sfcc-option-id']] = s.component.custom['v-sfcc-option-default-value'];
                    }
                }

                if (s.component.custom['v-sfcc-option-value']) {
                    options[s.component.custom['v-sfcc-option-id']] = s.component.custom['v-sfcc-option-value'];
                }

                if (s.component.custom['v-sfcc-option-also-id']) {
                    if (s.component.custom['v-sfcc-option-also-from']) {
                        const selected = controller.selectedAtPlacement(s.component.custom['v-sfcc-option-also-from']);

                        if (selected && selected.custom['v-ags-code']) {
                            options[s.component.custom['v-sfcc-option-also-id']] = selected.custom['v-ags-code'];
                        }
                    }
                }

                // Special case for addons redirect.
                if (s.component.custom['v-stamping-use-symbols-addon'] === 'yes') {
                    if (s.component.custom['v-sfcc-option-snow-value']) {
                        options[s.component.custom['v-sfcc-option-id']] = s.component.custom['v-sfcc-option-snow-value'];
                    }

                    if (s.component.custom['v-sfcc-option-snow-also-id']) {
                        if (s.component.custom['v-sfcc-option-snow-also-from']) {
                            const selected = controller.selectedAtPlacement(s.component.custom['v-sfcc-option-snow-also-from']);

                            if (selected && selected.custom['v-ags-code']) {
                                options[s.component.custom['v-sfcc-option-snow-also-id']] = selected.custom['v-ags-code'];
                            }
                        }
                    }
                }
            }
        }

        const flat = [];

        // eslint-disable-next-line no-restricted-syntax
        for (const k of Object.keys(options)) {
            let name = null;

            if (productData?.options) {
                const option = productData.options.find((x) => x.id === k);
                if (option) {
                    const value = option.values.find((x) => x.id === options[k]);

                    if (value) {
                        name = value.name;
                    }
                }
            }

            if (includeNames) {
                flat.push({
                    option_id: k,
                    option_value_id: options[k],
                    option_name: name,
                    option_image: '',
                });
            } else {
                flat.push({
                    option_id: k,
                    option_value_id: options[k],
                });
            }
        }

        return flat;
    },

    getNames(controller, placements) {
        if (placements.includes('/')) {
            return this.getNamesWith(controller, placements, '/');
        }

        if (placements.includes(',')) {
            return this.getNamesWith(controller, placements, ',');
        }

        return this.getNamesWith(controller, placements, ' ');
    },

    getNamesWith(controller, placements, separator) {
        const names = [];

        const codes = placements.split(separator).map((x) => x.trim()).filter((x) => x.length > 0);

        // eslint-disable-next-line no-restricted-syntax
        for (const code of codes) {
            const selected = controller.selectedAtPlacement(code);

            if (selected && !selected.placeholder) {
                names.push(controller.componentNames(selected).join(''));
            }
        }

        return names.join(separator);
    },

    mapOrderBlueprintItemValue(controller, index) {
        if (controller.blueprint.custom[`v-order-${index}-text`]) {
            return controller.blueprint.custom[controller.blueprint.custom[`v-order-${index}-text`]] ?? '';
        }

        if (controller.blueprint.custom[`v-order-${index}-id-of`]) {
            const selected = controller.selectedAtPlacement(controller.blueprint.custom[`v-order-${index}-id-of`]);

            if (selected) {
                return selected.custom['v-id'];
            }
        }

        if (controller.blueprint.custom[`v-order-${index}-name-of`]) {
            const selected = this.getNames(controller, controller.blueprint.custom[`v-order-${index}-name-of`]);

            if (selected && selected.length > 0) {
                return selected;
            }
        }

        if (controller.blueprint.custom[`v-order-${index}-code`]) {
            const code = controller.blueprint.custom[`v-order-${index}-code`];

            if (code === '<ignore>') {
                return null;
            }

            return code;
        }

        return null;
    },

    mapOrderItemValue(controller, state, index) {
        if (state.component.custom[`v-order-${index}-price`] === 'component') {
            let price = this.getOptionPriceValue(controller, state.component);

            if (price) {
                return +price.value;
            }

            price = this.getPrice(controller, state.component);

            if (price) {
                return +price;
            }
        }

        if (state.component.custom[`v-order-${index}-feature-text`]) {
            const parts = state.component.custom[`v-order-${index}-feature-text`].split(':');

            return `${parts[0]}:${state.component.custom[parts[1]] ?? ''}`;
        }

        if (state.component.custom[`v-order-${index}-text`]?.length > 0) {
            return state.component.custom[state.component.custom[`v-order-${index}-text`]] ?? '';
        }

        if (state.component.custom[`v-order-${index}-id-of`]?.length > 0) {
            const selected = controller.selectedAtPlacement(state.component.custom[`v-order-${index}-id-of`]);

            if (selected) {
                return selected.custom['v-id'];
            }
        }

        if (state.component.custom[`v-order-${index}-code-of`]?.length > 0) {
            const selected = controller.selectedAtPlacement(state.component.custom[`v-order-${index}-code-of`]);

            if (selected) {
                return selected.placementIndependentCode;
            }
        }

        if (state.component.custom[`v-order-${index}-feature-of`]?.length > 0) {
            const parts = state.component.custom[`v-order-${index}-feature-of`].split(':');

            const selected = controller.selectedAtPlacement(parts[1]);

            if (selected) {
                return `${parts[0]}:${selected.custom['v-ags-code']}`;
            }
        }

        if (state.component.custom[`v-order-${index}-name-of`]?.length > 0) {
            const selected = this.getNames(controller, state.component.custom[`v-order-${index}-name-of`]);

            if (selected && selected.length > 0) {
                return selected;
            }
        }

        if (state.component.custom[`v-order-${index}-code`]) {
            const code = state.component.custom[`v-order-${index}-code`];

            if (code === '<ignore>') {
                return null;
            }

            return code;
        }

        return null;
    },

    mapOrderItemPlacementValue(controller, state, index) {
        if (state.placement.custom[`v-order-${index}-price`] === 'component') {
            let price = this.getOptionPriceValue(controller, state.component);

            if (price) {
                return +price.value;
            }

            price = this.getPrice(controller, state.component);

            if (price) {
                return +price;
            }
        }

        if (state.placement.custom[`v-order-${index}-feature-text`]) {
            const parts = state.placement.custom[`v-order-${index}-feature-text`].split(':');

            return `${parts[0]}:${state.placement.custom[parts[1]] ?? ''}`;
        }

        if (state.placement.custom[`v-order-${index}-text`]) {
            return state.placement.custom[state.placement.custom[`v-order-${index}-text`]] ?? '';
        }

        if (state.placement.custom[`v-order-${index}-id-of`]) {
            const selected = controller.selectedAtPlacement(state.placement.custom[`v-order-${index}-id-of`]);

            if (selected) {
                return selected.custom['v-id'];
            }
        }

        if (state.placement.custom[`v-order-${index}-code-of`]) {
            const selected = controller.selectedAtPlacement(state.placement.custom[`v-order-${index}-code-of`]);

            if (selected && !selected.placeholder) {
                return selected.placementIndependentCode;
            }
        }

        if (state.placement.custom[`v-order-${index}-feature-of`]) {
            const parts = state.placement.custom[`v-order-${index}-feature-of`].split(':');

            const selected = controller.selectedAtPlacement(parts[1]);

            if (selected) {
                return `${parts[0]}:${selected.custom['v-ags-code']}`;
            }
        }

        if (state.placement.custom[`v-order-${index}-name-of`]) {
            const selected = this.getNames(controller, state.placement.custom[`v-order-${index}-name-of`]);

            if (selected && selected.length > 0) {
                return selected;
            }
        }

        if (state.placement.custom[`v-order-${index}-code`]) {
            const code = state.placement.custom[`v-order-${index}-code`];

            if (code === '<ignore>') {
                return null;
            }

            return code;
        }

        return null;
    },

    mapOrderItemCode(controller, code, context) {
        if (code === 'special-orientation') {
            const products = [];

            // eslint-disable-next-line no-restricted-syntax
            for (const p of this.selectedProducts) {
                products.push(p.custom?.['t-orientation']);
            }

            return products.join(',');
        }

        if (code === 'special-length') {
            const products = [];

            // eslint-disable-next-line no-restricted-syntax
            for (const p of this.selectedProducts) {
                products.push(p.custom?.['t-length']);
            }

            return products.join(',');
        }

        if (code === 'special-setcomp') {
            const products = [];

            // eslint-disable-next-line no-restricted-syntax
            for (const p of this.selectedProducts) {
                products.push(p.custom?.['t-setcomp']);
            }

            return products;
        }

        if (code === 'special-setcomp-name') {
            const products = [];

            // eslint-disable-next-line no-restricted-syntax
            for (const p of this.selectedProducts) {
                products.push(p.custom?.['t-setcomp-name']);
            }

            return products;
        }

        if (code === 'special-setcomp-grind') {
            const products = [];

            // eslint-disable-next-line no-restricted-syntax
            for (const p of this.selectedProducts) {
                products.push(p.custom?.['t-grind']);
            }

            return products;
        }

        if (code === 'special-setcomp-loft') {
            const products = [];

            // eslint-disable-next-line no-restricted-syntax
            for (const p of this.selectedProducts) {
                products.push(p.custom?.['t-loft']);
            }

            return products;
        }

        if (code === 'special-setcomp-bounce') {
            const products = [];

            // eslint-disable-next-line no-restricted-syntax
            for (const p of this.selectedProducts) {
                products.push(p.custom?.['t-bounce']);
            }

            return products;
        }

        if (code === 'special-wedge-id') {
            return controller.blueprint.styleCode;
        }

        if (code === 'special-wedge-price') {
            const price = controller.blueprint.custom[`v-price-${this.options.currency}`];

            return parseFloat(price).toFixed(2);
        }

        if (code === 'special-wedge-total') {
            return this.currentPrice?.current.toFixed(2);
        }

        if (code === 'special-recipe') {
            return context.recipe.id;
        }

        if (code === 'special-preview') {
            let v = this.lastImageUrl;

            if (context?.recipe) {
                const mainView = context.recipe.views.find((x) => x.code === 'Face');
                if (mainView) {
                    v = mainView.previewJpg;
                }
            }

            if (v.startsWith('//')) {
                v = `http:${v}`;
            }

            return v;
        }

        for (let i = 1; i <= 20; i += 1) {
            const index = `${i}`;

            const item = `v-order-${index}-item`;

            if (controller.blueprint.custom?.[item] === code) {
                const result = this.mapOrderBlueprintItemValue(controller, index);

                if (result) {
                    return result;
                }
            }
        }

        // eslint-disable-next-line no-restricted-syntax
        for (const s of controller.state) {
            for (let i = 1; i <= 20; i += 1) {
                const index = `${i}`;

                if (s.component.custom['v-stamping-use-symbols-addon'] === 'yes') {
                    const item = `v-order-${index}-snow-item`;

                    if (s.component.custom?.[item] === code) {
                        const result = this.mapOrderItemValue(controller, s, `${index}-snow`);

                        if (result) {
                            return result;
                        }
                    }
                }

                const item = `v-order-${index}-item`;

                if (s.component.custom?.[item] === code) {
                    const result = this.mapOrderItemValue(controller, s, index);

                    if (result) {
                        return result;
                    }
                }

                if (s.placement.custom?.[item] === code) {
                    const result = this.mapOrderItemPlacementValue(controller, s, index);

                    if (result) {
                        return result;
                    }
                }
            }
        }

        return null;
    },

    addOrderItem(controller, templateNode, rootNode, context) {
        if (templateNode.element) {
            const el = rootNode;

            if (templateNode.value) {
                // eslint-disable-next-line
                console.log(`Map ${templateNode.element} as ${templateNode.value}`);

                const mapped = this.mapOrderItemCode(controller, templateNode.value, context);

                if (mapped) {
                    el[templateNode.element] = mapped;
                } else if (templateNode.default != null) {
                    el[templateNode.element] = templateNode.default;
                } else {
                    el[templateNode.element] = templateNode.value;
                }
            } else {
                const mapped = this.mapOrderItemCode(controller, templateNode.element, context);

                if (mapped) {
                    el[templateNode.element] = mapped;
                }
            }

            if (templateNode.attributes) {
                // eslint-disable-next-line no-restricted-syntax
                for (const attribute of templateNode.attributes) {
                    let useValue = null;

                    if (attribute.value) {
                        useValue = this.mapOrderItemCode(controller, attribute.value, context);
                    }

                    if (useValue == null) {
                        if (attribute.default != null) {
                            useValue = attribute.default;
                        }
                    }

                    if (useValue == null) {
                        useValue = attribute.value;
                    }

                    if (useValue == null) {
                        useValue = '';
                    }

                    el[attribute.attribute] = useValue;
                }
            }

            if (templateNode.elements) {
                el[templateNode.element] = {};
                // eslint-disable-next-line no-restricted-syntax
                for (const childTemplate of templateNode.elements) {
                    this.addOrderItem(controller, childTemplate, el[templateNode.element]);
                }
            }

            if (templateNode.multiple) {
                // eslint-disable-next-line no-restricted-syntax
                for (const childTemplate of templateNode.multiple) {
                    if (childTemplate.element) {
                        // eslint-disable-next-line no-restricted-syntax
                        for (const s of controller.state) {
                            for (let i = 1; i <= 10; i += 1) {
                                const item = `v-order-${i}-item`;

                                if (s.component.custom?.[item] === childTemplate.element) {
                                    const result = this.mapOrderItemValue(controller, s, i);

                                    if (result) {
                                        if (el[templateNode.element] == null) {
                                            el[templateNode.element] = [];
                                        }

                                        el[templateNode.element].push(result);
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }
    },

    formatDescriptionData(controller, recipe) {
        const xml = {};

        const root = xml;

        const context = {
            recipe,
        };

        // eslint-disable-next-line no-restricted-syntax
        for (const templateNode of orderItemTemplate) {
            this.addOrderItem(controller, templateNode, root, context);
        }

        const xmlText = xml;

        return xmlText;
    },
};
